export const devEnv = {
  baseUrl: {
    notification: 'http://localhost:7080',
  },
};
